import { Goehler_Tool_REST_Client } from '@app/utils/rest-client'
import { handle_api_error } from '@app/utils/api-error'
import ClickEvent = JQuery.ClickEvent

export class Project_Status_Controller {
    rest_client: Goehler_Tool_REST_Client

    constructor() {
        this.rest_client = new Goehler_Tool_REST_Client()
    }

    ready() {
        this.init_actions()
    }

    init_actions() {
        jQuery( '[data-action="reset-status"]' ).on( 'click', () => this.reset_status_confirmation() )
        jQuery( 'button[data-approval-status]' ).on( 'click', ( e: ClickEvent ) => this.change_status( e ) )
    }

    /**
     * Öffnet die Bestätigung zum Zurücksetzen des Projekts.
     */
    reset_status_confirmation() {
        const modal = app.get_modal( 'reset-status-confirmation' )

        if ( ! modal ) {
            return
        }

        modal.modal(
            {
                onApprove: () => {
                    void this.api_reset_status()
                }
            }
        )
        modal.modal( 'show' )
    }

    /**
     * Setzt das abgeschlossene Projekt als Reklamation in die Montage zurück.
     */
    async api_reset_status() {
        const TASK = 'Zurücksetzen des Projekts'

        jQuery( '.full-screen-loading-dimmer .dimmer' )
            .dimmer( { variation: 'inverted', closable: false } )
            .dimmer( 'show' )

        try {
            const response = await this.rest_client.post(
                'goehler-tool/v1/projects/reset-status',
                {
                    post_id: gt_ajax_object.post_id,
                }
            ) as { toast: string, redirect: string }

            if ( response.redirect ) {
                window.location.href = response.redirect
                return
            }

            app.show_toast_ajax_response( response.toast )
        } catch ( error ) {
            jQuery( '.dimmable' ).dimmer( 'hide' )

            handle_api_error( error, TASK )
        }
    }

    /**
     * Startet die Freigabekette für den aktuellen Bereich.
     *
     * Bei der Oberfläche wird zuerst der Lagerplatz abgefragt und gespeichert,
     * damit er auch dann festgehalten ist, wenn die Freigabe abgebrochen wird.
     */
    change_status( e: ClickEvent ) {
        const button = e.currentTarget as HTMLElement

        if ( button.dataset.isAllowed !== '1' ) {
            return
        }

        if ( action_tab === 'finishing' ) {
            project.init_modal_update_storage_yard_assembly()
            return
        }

        void this.api_approve_status_check()
    }

    /**
     * Ermittelt, ob für den Bereich eine Begründung der Zeitüberschreitung
     * erforderlich ist, und öffnet anschließend die Freigabe-Bestätigung.
     */
    async api_approve_status_check() {
        console.log( '[REST] approve status check' )

        const TASK = 'Prüfen der Freigabe'

        const button = document.querySelector( 'button[data-approval-status]' ) as HTMLElement

        if ( ! button ) {
            return
        }

        const data: Record<string, unknown> = {
            post_id: gt_ajax_object.post_id,
            current: String( button.dataset.currentStatus ),
        }

        try {
            const response = await this.rest_client.post(
                'goehler-tool/v1/projects/approve-status-check',
                data
            ) as {
                reason_required: boolean,
                reason?: string,
                status: string
            }

            console.log( `${ TASK }?`, response )

            this.init_modal_approve_status(
                String( button.dataset.currentStatus ),
                String( button.dataset.approvalStatus ),
                response.reason_required,
                response.reason ?? ''
            )
        } catch ( error ) {
            handle_api_error( error, TASK )
        }
    }

    /**
     * Öffnet die Freigabe-Bestätigung und blendet bei Bedarf das
     * Begründungsfeld für die Zeitüberschreitung ein.
     *
     * @param current         Slug des abzuschließenden Bereichs.
     * @param next            Slug des Zielbereichs.
     * @param reason_required Blendet das Begründungsfeld als Pflichtfeld ein.
     * @param reason          Vorhandene Begründung zum Vorbefüllen.
     */
    init_modal_approve_status( current: string, next: string, reason_required: boolean, reason: string ) {
        const modal = app.get_modal( 'approve-status-confirm' )

        if ( ! modal ) {
            return
        }

        const form = modal.find( '#form-approve-status-reason' )
        const textarea = modal.find( '#approve-status-reason' )

        form.prop( 'hidden', ! reason_required )

        textarea.off( 'input.approve_status' )

        if ( reason_required ) {
            textarea.val( reason )
            textarea.on( 'input.approve_status', () => this.toggle_approve_button( modal ) )
        }

        this.toggle_approve_button( modal )

        modal.modal(
            {
                onApprove: () => {
                    if ( reason_required && this.reason_is_empty( modal ) ) {
                        return false
                    }

                    void this.api_approve_status( current, next, reason_required ? String( textarea.val() ).trim() : '' )
                }
            }
        )
        modal.modal( 'show' )
    }

    /**
     * Prüft, ob die Begründungs-Textarea leer ist.
     */
    reason_is_empty( modal: JQuery ): boolean {
        return String( modal.find( '#approve-status-reason' ).val() ?? '' ).trim() === ''
    }

    /**
     * Blockiert den Freigabe-Button, solange eine erforderliche Begründung fehlt.
     */
    toggle_approve_button( modal: JQuery ) {
        const required = ! modal.find( '#form-approve-status-reason' ).prop( 'hidden' )

        modal.find( '.positive.button' ).toggleClass( 'disabled', required && this.reason_is_empty( modal ) )
    }

    /**
     * Gibt den Bereich frei und setzt das Projekt in den Folgestatus.
     *
     * @param current Slug des abzuschließenden Bereichs.
     * @param next    Slug des Zielbereichs.
     * @param reason  Begründung der Zeitüberschreitung, leer wenn nicht erforderlich.
     */
    async api_approve_status( current: string, next: string, reason: string ) {
        console.log( '[REST] approve status' )

        const TASK = 'Freigeben des Projekts'

        const dimmer = jQuery( '.full-screen-loading-dimmer .dimmer' )

        dimmer
            .dimmer( { variation: 'inverted', closable: false } )
            .dimmer( 'show' )

        try {
            const response = await this.rest_client.post(
                'goehler-tool/v1/projects/approve-status',
                {
                    post_id: gt_ajax_object.post_id,
                    current,
                    next,
                    reason,
                }
            ) as { toast: string, redirect: string }

            dimmer.removeClass( 'inverted' )
            dimmer.html( '<h2 class="ui inverted active icon header"><i class="checkmark icon"></i>Geschafft!</h2>' )

            app.play_confetti( 'stars' )

            if ( response.redirect ) {
                setTimeout( () => window.location.href = response.redirect, 3000 )
                return
            }

            jQuery( '.dimmable' ).dimmer( 'hide' )

            app.show_toast_ajax_response( response.toast )
        } catch ( error ) {
            jQuery( '.dimmable' ).dimmer( 'hide' )

            handle_api_error( error, TASK )
        }
    }
}
